import {
  createMenu,
  createStore,
  deleteMenu,
  deleteStore,
  getMenu,
  getMenuItemList,
  getMenuList,
  getMenuTemplate,
  getStore,
  getStoreList,
  updateMenu,
  updateStore,
} from '@/api/store';

import {
  GET_STORE_LIST,
  GET_STORE_LIST_DONE,
  GET_STORE,
  CREATE_STORE,
  UPDATE_STORE,
  DELETE_STORE,
  GET_MENU,
  GET_MENU_LIST,
  CREATE_MENU,
  UPDATE_MENU,
  DELETE_MENU,
  GET_MENU_ITEM_LIST,
  GET_MENU_TEMPLATE,
} from './constants';

export default {
  async [GET_STORE_LIST]({ commit }, payload) {
    try {
      const res = await getStoreList(payload);
      commit(GET_STORE_LIST_DONE, res);
      return Promise.resolve(res);
    } catch (error) {
      commit(GET_STORE_LIST_DONE, {});
      return Promise.reject(error);
    }
  },
  async [GET_STORE](ctx, storeId) {
    const { store } = await getStore(storeId);
    return store;
  },
  async [CREATE_STORE](ctx, storeInfo) {
    const { store } = await createStore(storeInfo);
    return store;
  },
  async [UPDATE_STORE](ctx, { storeId, payload }) {
    const res = await updateStore(storeId, payload);
    return res;
  },
  async [DELETE_STORE](ctx, storeId) {
    const res = await deleteStore(storeId);
    return res;
  },
  async [GET_MENU_LIST](ctx, storeId) {
    const { menus } = await getMenuList(storeId);
    return menus;
  },
  async [GET_MENU](ctx, { storeId, menuId }) {
    const { menu } = await getMenu(storeId, menuId);
    return menu;
  },
  async [CREATE_MENU](ctx, { storeId, menu }) {
    const { menu: createdMenu } = await createMenu(storeId, menu);
    return createdMenu;
  },
  async [UPDATE_MENU](ctx, { storeId, menuId, menu }) {
    const res = await updateMenu(storeId, menuId, menu);
    return res;
  },
  async [DELETE_MENU](ctx, { storeId, menuId }) {
    const res = await deleteMenu(storeId, menuId);
    return res;
  },
  async [GET_MENU_ITEM_LIST](ctx, { storeId, menuId }) {
    const { menu = {} } = await getMenuItemList(storeId, menuId);
    return menu;
  },
  async [GET_MENU_TEMPLATE]() {
    const { menu_models: menuTemplate } = await getMenuTemplate();
    return menuTemplate;
  },
};
